// extracted by mini-css-extract-plugin
export default {"headline":"+t9krTpVEjZM09Qa5LECBg=="};